import { TRASHIE_GA_TAG_ID } from './config';

import { isProd } from '../../../config/config';

const TRASHIE_WEBSITE_URL = 'https://trashie.io';
const FORDAYS_WEBSITE_URL = 'https://fordays.com';
const HELP_URL = 'https://help.trashie.io/';
const TERMS_OF_SERVICE_URL = `${TRASHIE_WEBSITE_URL}/terms-of-service`;
const PRIVACY_POLICY_URL = `${TRASHIE_WEBSITE_URL}/privacy-policy`;
const SUPPORT_URL = `${TRASHIE_WEBSITE_URL}/support`;
const BUG_REPORT_URL = `${TRASHIE_WEBSITE_URL}/bug-report`;
const THE_TBB_URL = `${TRASHIE_WEBSITE_URL}/the-tbb`;
const HOW_WE_RECYCLE_URL = `${TRASHIE_WEBSITE_URL}/how-we-recycle`;
const CONTACT_US_URL = `${TRASHIE_WEBSITE_URL}/contact`;
const PARTNERSHIPS_URL = `${TRASHIE_WEBSITE_URL}/partnerships`;
const BROWSER_EXTENSION_URL = `${TRASHIE_WEBSITE_URL}/browser-extension`;
const FAQS_URL = `${TRASHIE_WEBSITE_URL}/faqs`;
const HOW_WE_DONATE_URL = `${TRASHIE_WEBSITE_URL}/how-we-donate`;
const TAKE_BACK_BAG_COLLECTION_URL = `${TRASHIE_WEBSITE_URL}/tbb-collection`;

const MEMBERSHIP_TERMS_URL = `${TRASHIE_WEBSITE_URL}/membershipterms`;
const MEMBERSHIP_FAQS_URL = `${HELP_URL}en-US/articles/298250-def4cc044c9d4d2f810543e758912502`;

const SHOP_TRASHIE_URL = 'https://shop.trashie.io';
/** Main Trashie web app (post-checkout redirect from shop / cash flows). */
const TRASHIE_APP_URL = 'https://app.trashie.io';
const TAKE_BACK_BAG_URL = `${SHOP_TRASHIE_URL}/products/take-back-bag`;
const TAKE_BACK_BAG_RAINBOW_3_PACK_URL = `${SHOP_TRASHIE_URL}/products/take-back-bag-rainbow-3-pack`;
const TAKE_BACK_BAG_COTTON_FABRIC_SCRAP_URL = `${SHOP_TRASHIE_URL}/products/cotton-fabric-scrap-take-back-bag`;
const TAKE_BACK_BAG_DOUBLE_RAINBOW_URL = `${SHOP_TRASHIE_URL}/products/double-rainbow-deal-by-trashie`;
const TAKE_BACK_BAG_KIDS_URL = `${SHOP_TRASHIE_URL}/products/kids-take-back-bag`;
const TECH_BACK_BOX_MEDIUM_URL = `${SHOP_TRASHIE_URL}/products/tech-take-back-box-medium`;
const TECH_BACK_BOX_SMALL_URL = `${SHOP_TRASHIE_URL}/products/small-tech-take-back-bag`;
const TAKE_BACK_BAG_PRODUCTS_URL = `${SHOP_TRASHIE_URL}/products`;
const DOWNLOAD_EXTENSION_URL = 'https://chromewebstore.google.com/detail/trashie/mhaamcbaeggmpmmdppgeimpkmnfmhgpc';

const PARTNERSHIPS_MAIL_TO = "mailto:partnerships@trashie.io?subject=I'd%20love%20to%20get%20more%20information%20about%20partnering%20with%20Trashie!";
const STRIPE_URL = 'https://stripe.com/';
const STRIPE_TERMS_URL = `${STRIPE_URL}/legal/consumer`;
const STRIPE_PRIVACY_URL = `${STRIPE_URL}/privacy`;

const TRASHIE_SOCIAL_NETWORKS = {
  INSTAGRAM: 'https://www.instagram.com/trashie',
  TIKTOK: 'https://www.tiktok.com/@trashie',
  FACEBOOK: 'https://www.facebook.com/fordaysfordays',
};

const GOOGLE_TAG_MANAGER_URL =
  `https://www.googletagmanager.com/gtag/js?id=${isProd() ? TRASHIE_GA_TAG_ID.PRODUCTION : TRASHIE_GA_TAG_ID.STAGING}`;

const WILDLINK_AFFILIATE_LINK_URL = 'https://wild.link/e';

const RECYCLING_BOX_VIDEO_URL = 'https://storage.googleapis.com/trashie-public-assets/videos/BATTERY-STICKERS/sticker-animation_1.mp4';
const RECYCLING_BOX_STICKERS_URL = 'https://storage.googleapis.com/trashie-public-assets/pdfs/Lithium-Battery-Labels.pdf';

const WELCOME_PAY_ON_SHIP_VIDEO_URL = 'https://cdn.trashie.io/videos/homepage/welcome_background_mobile.mp4';

const APP_STORE_URL = 'https://apps.apple.com/app/id6747362894';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.trashie.app';

export {
  TRASHIE_WEBSITE_URL,
  FORDAYS_WEBSITE_URL,
  HELP_URL,
  TERMS_OF_SERVICE_URL,
  PRIVACY_POLICY_URL,
  SUPPORT_URL,
  BUG_REPORT_URL,
  TRASHIE_APP_URL,
  TAKE_BACK_BAG_URL,
  TAKE_BACK_BAG_RAINBOW_3_PACK_URL,
  TAKE_BACK_BAG_COTTON_FABRIC_SCRAP_URL,
  TAKE_BACK_BAG_DOUBLE_RAINBOW_URL,
  TAKE_BACK_BAG_KIDS_URL,
  TECH_BACK_BOX_MEDIUM_URL,
  TECH_BACK_BOX_SMALL_URL,
  TAKE_BACK_BAG_PRODUCTS_URL,
  DOWNLOAD_EXTENSION_URL,
  PARTNERSHIPS_URL,
  BROWSER_EXTENSION_URL,
  FAQS_URL,
  HOW_WE_DONATE_URL,
  TAKE_BACK_BAG_COLLECTION_URL,
  PARTNERSHIPS_MAIL_TO,
  THE_TBB_URL,
  HOW_WE_RECYCLE_URL,
  CONTACT_US_URL,
  TRASHIE_SOCIAL_NETWORKS,
  GOOGLE_TAG_MANAGER_URL,
  WILDLINK_AFFILIATE_LINK_URL,
  RECYCLING_BOX_VIDEO_URL,
  RECYCLING_BOX_STICKERS_URL,
  WELCOME_PAY_ON_SHIP_VIDEO_URL,
  MEMBERSHIP_TERMS_URL,
  MEMBERSHIP_FAQS_URL,
  STRIPE_URL,
  STRIPE_TERMS_URL,
  STRIPE_PRIVACY_URL,
  APP_STORE_URL,
  PLAY_STORE_URL,
};
